// @ts-nocheck
import { getBillTos, GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import { createHandlerChainRunnerOptionalParameter } from "@toolkit/Modules/client-framework/HandlerCreator";
import { ApiHandler } from "@toolkit/Modules/client-framework/HandlerCreator";
import { useDispatch } from "react-redux";

type HandlerType = ApiHandler<GetBillTosApiParameter, CompanyLocation[]>;

export const DispatchBeingLoadLocation: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ReportOrderFrequency/BeginLoadLocations",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.apiParameter.expand = ["shipTos"];
};
// id should be shipTo.id, remove erp number.  name should be shipTo.customerName.
export const RequestDataFromApi: HandlerType = async props => {
    const results = await getBillTos(props.apiParameter);
    const mapped: CompanyLocation[] =
        results.billTos?.map<CompanyLocation>(billTo => {
            return {
                id: billTo.id,
                name: `${billTo.companyName}`,
                customers:
                    billTo.shipTos
                        ?.filter(shipTo => shipTo.isNew === false && shipTo.label !== "Use Billing Address")
                        .map<CustomerLocation>(shipTo => {
                            return {
                                id: shipTo.id,
                                companyId: billTo.id,
                                name: shipTo.customerName,
                                displayName: `${shipTo.customerName} ${shipTo.address1} ${shipTo.address2}`,
                                customerSequence: shipTo.customerSequence,
                            };
                        }) ?? [],
            };
        }) ?? [];
    props.apiResult = mapped;
};

export const useLoadLocation = () => {
    const dispatch = useDispatch();
    const loadLocationViaHooks = async () => {
        const apiParameter = { expand: ["shipTos"] };
        const results = await getBillTos({ expand: ["shipTos"] });
        const mapped: CompanyLocation[] =
            results.billTos?.map<CompanyLocation>(billTo => {
                return {
                    id: billTo.id,
                    name: `${billTo.companyName} (${billTo.customerNumber})`,
                    customers:
                        billTo.shipTos
                            ?.filter(shipTo => shipTo.isNew === false && shipTo.label !== "Use Billing Address")
                            .map<CustomerLocation>(shipTo => {
                                return {
                                    id: shipTo.id,
                                    companyId: billTo.id,
                                    name: shipTo.address1,
                                    displayName: `${shipTo.address1} ${shipTo.address2}`,
                                    customerSequence: shipTo.customerSequence,
                                };
                            }) ?? [],
                };
            }) ?? [];
        dispatch({
            type: "Store/Pages/ReportOrderFrequency/CompletedLoadLocations",
            collection: mapped,
            parameter: apiParameter,
        });
    };
    return loadLocationViaHooks;
};
export const DispatchCompleteLoadBillTos: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ReportOrderFrequency/CompletedLoadLocations",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [DispatchBeingLoadLocation, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadBillTos];

const loadLocations = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadLocations");
export default loadLocations;

export interface CompanyLocation {
    id: string;
    name: string;
    customers: CustomerLocation[];
}

export interface CustomerLocation {
    id: string;
    companyId: string;
    name: string;
    displayName: string;
    customerSequence: string;
}
